import React, { createContext, useEffect, useState } from 'react'
import { GetTokenWithExpiry } from '../utilities/tokenSetting'
export const Context = createContext({
  auth: false,
  setAuth: () => {},
  GPS: null,
  setGPS: () => {},
  share: false,
  setShare: () => {},
  url: '',
  setUrl: () => {},
})

const AppContext = ({ children }) => {
  const [auth, setAuth] = useState(false)
  const [share, setShare] = useState(false)
  const [url, setUrl] = useState('')
  const [GPS, setGPS] = useState(null)
  useEffect(() => {
    if (GetTokenWithExpiry('token')) {
      setAuth(true)
    }
  }, [])
  return (
    <Context.Provider
      value={{
        auth: auth,
        setAuth: setAuth,
        GPS: GPS,
        setGPS: setGPS,
        share: share,
        setShare: setShare,
        url: url,
        setUrl: setUrl,
      }}
    >
      {children}
    </Context.Provider>
  )
}
export default AppContext
